import { Bell, Search, Mail, Eye, ShoppingCart, Users, Briefcase, Building2 } from "lucide-react";

const funnel = [
  { icon: Bell, label: "Notice of Appeal Filed", desc: "Trigger event detected" },
  { icon: Search, label: "Identify Attorney", desc: "Match filing to firm" },
  { icon: Mail, label: "Direct Outreach", desc: "Targeted contact" },
  { icon: Eye, label: "Preview / Demo", desc: "Show immediate value" },
  { icon: ShoppingCart, label: "Purchase", desc: "Convert to customer" },
];

const segments = [
  { icon: Briefcase, label: "Law firms", desc: "Primary customer base" },
  { icon: Building2, label: "Smaller firms", desc: "Currently priced out of traditional providers" },
];

export default function GoToMarketSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-gtm-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        GO-TO-MARKET
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Built-in demand signal through appellate filings
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-4 md:gap-8 lg:gap-10 min-h-0">
        <div className="flex-1">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
            Acquisition Funnel
          </div>
          <div className="flex flex-col gap-1">
            {funnel.map((step, i) => (
              <div key={i} className="flex flex-col">
                <div
                  className="flex items-center gap-3 rounded-lg p-2.5 sm:p-3 border border-slate-100 bg-white"
                  style={{
                    marginLeft: `${i * 12}px`,
                    width: `calc(100% - ${i * 12}px)`,
                  }}
                >
                  <div className="w-7 h-7 bg-blue-50 rounded flex items-center justify-center shrink-0">
                    <step.icon className="h-3.5 w-3.5 text-blue-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-slate-900 font-heading">
                      {step.label}
                    </div>
                    <div className="text-xs text-slate-400 font-body">
                      {step.desc}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-[220px] sm:w-[260px] shrink-0 flex flex-col">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
            Target Segments
          </div>
          <div className="flex flex-col gap-3 flex-1 justify-center">
            {segments.map((s, i) => (
              <div
                key={i}
                className="bg-slate-50 rounded-lg p-3 sm:p-4 border border-slate-100"
              >
                <div className="flex items-center gap-2 mb-1">
                  <s.icon className="h-3.5 w-3.5 text-blue-600" />
                  <span className="text-xs font-semibold text-slate-900 font-heading">
                    {s.label}
                  </span>
                </div>
                <p className="text-xs text-slate-500 font-body">{s.desc}</p>
              </div>
            ))}
          </div>
          <p className="text-xs text-slate-400 font-body mt-3">
            Land in NY, replicate by state, expand to firm-level subscriptions
          </p>
        </div>
      </div>
    </div>
  );
}
